import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const AkornAdvanceShipNotice = () => {
	const fileName = "Akorn Advance Ship Notice";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const userData = JSON.parse(localStorage.getItem("userData"));
	const history = useHistory();
	const [advanceShipNotice, setAdvanceShipNotice] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const columns = [
		{
			Header: "Shipped Date",
			accessor: "ShippedDate",
			filter: "ShippedDate",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Shipped Time",
			accessor: "ShippedTime",
			filter: "ShippedTime",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Ship To Name",
			accessor: "ShipToName",
			filter: "ShipToName",
			sortType: "basic",
			width: 250,
		},
		{
			Header: "Customer ID",
			accessor: "CustomerID",
			filter: "CustomerID",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Buyers Part Number",
			accessor: "BuyersPartNumber",
			filter: "BuyersPartNumber",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Purchase Order Number",
			accessor: "PurchaseOrderNumber",
			filter: "PurchaseOrderNumber",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Measurement Qualifier",
			accessor: "MeasurementQualifier",
			filter: "MeasurementQualifier",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Measurement Value",
			accessor: "MeasurementValue",
			filter: "MeasurementValue",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Measurement Code",
			accessor: "MeasurementCode",
			filter: "MeasurementCode",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Reference Identification Qualifier",
			accessor: "ReferenceIdentificationQualifier",
			filter: "ReferenceIdentificationQualifier",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Reference Identification Qualifier Number",
			accessor: "ReferenceIdentificationQualifierNumber",
			filter: "ReferenceIdentificationQualifierNumber",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Line Item Count",
			accessor: "LineItemCount",
			filter: "LineItemCount",
			sortType: "basic",
			width: 80,
		},
	];

	useEffect(() => {
		getProductTransfer();
	}, []);

	async function getProductTransfer() {
		setLoading(true);
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}&FileFormat=${outbounddata.FileFormat}`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const advanceShipNoticeResult = data.data;
				if (advanceShipNoticeResult.length > 0) {
					advanceShipNoticeResult.map((res) => {
						res.ShippedDate = moment(res.ShippedDate).format("MM/DD/YYYY");
					});
				}
				setAdvanceShipNotice(advanceShipNoticeResult);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				setHasError(true);
			});
	}

	const EnableAddEdit = () => {
		localStorage.setItem(
			"advanceShipNotice",
			JSON.stringify(advanceShipNotice)
		);
		history.push("/AdvanceShipEdiAddEdit");
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<div>
					{advanceShipNotice.length > 0 &&
						userData.RoleID === 1 &&
						outbounddata.Version_File === 0 &&
						(outbounddata.FileSentStatus === "Sent" ? (
							<Button type="submit" onClick={() => EnableAddEdit()}>
								Create Reversal
							</Button>
						) : (
							<Button type="submit" onClick={() => EnableAddEdit()}>
								Edit Records
							</Button>
						))}
					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(columns, advanceShipNotice, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>{`Error occurred. Unable to load ${fileName}.`}</p>
								) : (
									<Fragment>
										{advanceShipNotice.length > 0 ? (
											<ReactTable
												columns={columns}
												data={advanceShipNotice}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default AkornAdvanceShipNotice;
